export default __webpack_public_path__ + "static/media/admin-dashboard-icon.692fe508.svg";